import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Alert,
} from "reactstrap";

// Actions
import { EmailCategoryAction } from "../../../../store/actions";

// Import Breadcrumb
import Breadcrumbs from "../../../../components/Layout/Breadcrumb";

// Import DeleteModal
import EmailCategoryModal from "./EmailCategory";

// Import DeleteModal
import DeleteModal from "../../../../components/Common/DeleteModal";

// Import DataTable
import DataTable from "../../../../components/Common/DataTable";

import { getDataTableQuery, handleFilters } from "../../../../helpers/functions_helper";
import { useTranslation } from "react-i18next";



const EmailCategory = (props: any) => {
  const {t} = useTranslation();
  document.title = t("Email Template Category")+"| " + process.env.REACT_APP_NAME;
  const savedfilters = handleFilters("GET");
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "#",
      label: t("Email Template Category"),
      active: true,
    },
  ];

  let {
    datatableData,
    datatableErrorMsg,
    createEmailCategorySuccessMsg,
    createEmailCategoryErrorMsg,
    createEmailCategoryErrorData,

    duplicateEmailCategorySuccessMsg,
    duplicateEmailCategoryErrorMsg,
    duplicateEmailCategoryErrorData,

    updateEmailCategorySuccessMsg,
    updateEmailCategoryErrorMsg,
    updateEmailCategoryErrorData,
    deleteEmailCategorySuccessMsg,
    deleteEmailCategoryErrorMsg,
    deleteEmailCategoryErrorData,
    getEmailCategoryErrorMsg,
    loading,
  } = useSelector((state: any) => ({
    datatableData: state.EmailCategory.GET_EMAIL_TEMPLATE_CATEGORY_LIST_SUCCESS,
    datatableErrorMsg: state.EmailCategory.GET_EMAIL_TEMPLATE_CATEGORY_LIST_ERROR.message,

    createEmailCategorySuccessMsg:
      state.EmailCategory.CREATE_EMAIL_TEMPLATE_CATEGORY_SUCCESS.message,
    createEmailCategoryErrorMsg:
      state.EmailCategory.CREATE_EMAIL_TEMPLATE_CATEGORY_ERROR.message,
    createEmailCategoryErrorData:
      state.EmailCategory.CREATE_EMAIL_TEMPLATE_CATEGORY_ERROR.data,

    duplicateEmailCategorySuccessMsg:
      state.EmailCategory.CREATE_DUPLICATE_EMAIL_TEMPLATE_CATEGORY_SUCCESS.message,
    duplicateEmailCategoryErrorMsg:
      state.EmailCategory.CREATE_DUPLICATE_EMAIL_TEMPLATE_CATEGORY_ERROR.message,
    duplicateEmailCategoryErrorData:
      state.EmailCategory.CREATE_DUPLICATE_EMAIL_TEMPLATE_CATEGORY_ERROR.data,

    updateEmailCategorySuccessMsg:
      state.EmailCategory.UPDATE_EMAIL_TEMPLATE_CATEGORY_SUCCESS.message,
    updateEmailCategoryErrorMsg:
      state.EmailCategory.UPDATE_EMAIL_TEMPLATE_CATEGORY_ERROR.message,
    updateEmailCategoryErrorData:
      state.EmailCategory.UPDATE_EMAIL_TEMPLATE_CATEGORY_ERROR.data,

    deleteEmailCategorySuccessMsg:
      state.EmailCategory.DELETE_EMAIL_TEMPLATE_CATEGORY_SUCCESS.message,
    deleteEmailCategoryErrorMsg:
      state.EmailCategory.DELETE_EMAIL_TEMPLATE_CATEGORY_ERROR.message,
    deleteEmailCategoryErrorData:
      state.EmailCategory.DELETE_EMAIL_TEMPLATE_CATEGORY_ERROR.data,

    getEmailCategoryErrorMsg: state.EmailCategory.GET_EMAIL_TEMPLATE_CATEGORY_ERROR.message,

    loading: state.EmailCategory.loading,
  }));

  // DataTable ----------------------------------------------
  function renderHeaderHTML(column: any, colIndex: any) {
    return <span dangerouslySetInnerHTML={{ __html: column.text }} />;
  }
  function renderRowHTML(rowContent: any, row: any) {
    return <span dangerouslySetInnerHTML={{ __html: rowContent }} />;
  }

  const columns = [
    {
      dataField: "DT_RowIndex",
      text: t("Sr. No."),
      sort: false,
      search: false,
    },
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   search: true,
    // },
    {
      dataField: "module_value",
      text: t("Module"),
      sort: true,
      search: true,
      formatter: renderRowHTML,
    },
    {
      dataField: "email_template_category",
      text: t("Email Category"),
      sort: true,
      search: true,
      formatter: renderRowHTML,
    },    
    {
      dataField: "action",
      text: t("Action"),
      sort: false,
      search: false,
      formatter: (rowContent: any, row: any): any => {
        return (
          <div className="d-flex gap-2 text-end">
             <Link
              className="btn btn-pill btn-outline-danger btn-sm"
              to="#"
              onClick={() => onClickDuplicate(row)}
            >
              <i className="fa-regular fa-clone"></i> {t("Duplicate")}
            </Link>
            <Link 
              className="btn btn-pill btn-outline-primary btn-sm" 
              to="#"
              onClick={() => onClickEdit(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i> {t("Edit")}
            </Link>
            {/* <Link
              className="btn btn-pill btn-outline-danger btn-sm"
              to="#"
              onClick={() => onClickDelete(row)}
            >
              <i className="fa-regular fa-trash-can"></i> Delete
            </Link> */}
          </div>
        );
      },
    },
  ];

  const [loadingListData, setLoadingListData] = useState(true);
  const [datatableOptions, setDatatableOptions] = useState(
    savedfilters && savedfilters?.datatableOptions
    ? (savedfilters?.datatableOptions as any)
    : {
        draw: 1,
        page: 1,
        recordsTotal: 0,
        recordsFiltered: 0,
        sizePerPage: 20,
        searchText: "",
        sortField: "id",
        sortOrder: "desc",
      }
  );


  useEffect(()=> {
    if (loadingListData === true) {
      dispatch(
        EmailCategoryAction.getEmailCategoryList(
          getDataTableQuery(datatableOptions, columns),
          props.history
        )
      );
    }
  }, [loadingListData]);

  const [EmailCategoryListData, setEmailCategoryListData] = useState([]);
  useEffect(() => {
    if (datatableData) {
      setEmailCategoryListData(datatableData.data);

      const updatedDatatableOptions = {
        ...datatableOptions,
        recordsTotal: datatableData.recordsTotal,
        recordsFiltered: datatableData.recordsFiltered,
      };
      setDatatableOptions(updatedDatatableOptions);

      setLoadingListData(false);
      setLoader(false);
    }
  }, [datatableData]);

  const onTableChange = (type: any, newState: any) => {
    let draw = datatableOptions.draw + 1;
    let page = 1;
    if (type == "search") {
      page = 1;
    } else {
      page = newState.page;
    }
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: draw,
      page: page,
      sizePerPage: newState.sizePerPage,
      searchText: newState.searchText,
      sortField: newState.sortField,
      sortOrder: newState.sortOrder,
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };

  const clearFilter = () => {
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: 1,
      page: 1,
      sizePerPage: 20,
      searchText: "",
      sortField: "id",
      sortOrder: "desc",
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };
  // Datatable -------------------------------------------------

  // Delete Form --------------------------------------------------------
  const [deleteEmailCategory, setDeleteEmailCategory] = useState({ 
    id: "", 
    email_category_id: "" 
  });
  const [recordName, setRecordName] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (row: any) => {
    console.log(row);
    const deleteEmailCategoryData = {
      ...deleteEmailCategory,
      id: row.id,
      email_category_id: row.email_category_id,
    };
    setDeleteEmailCategory(deleteEmailCategoryData);
    setRecordName(row.task_type_value);
    setDeleteModal(true);
  };
  
  const handleDeleteEmailCategory = () => {
    dispatch(EmailCategoryAction.deleteEmailCategory(deleteEmailCategory, props.history));
  };
  // Delete Form --------------------------------------------------------

 // Duplicate

 const onClickDuplicate=(emailCategory:any)=>{
  dispatch(EmailCategoryAction.createDuplicateEmailCategory(emailCategory, props.history));
 }

  // Master Form -------------------------------------------------------- 
  const [EmailCategoryData, setEmailCategoryData] = useState({}); 

  const [masterFormModal, setMasterFormModal] = useState(false);
  const [masterFormModalTitle, setMasterFormModalTitle] = useState("Create task type");

  const onClickModal = () => {
    setEmailCategoryData('');
    setMasterFormModalTitle(t("Create email template category"));
    setMasterFormModal(true);
  };
  
  const onClickEdit = (row: any) => {
    setEmailCategoryData(row);
    setMasterFormModalTitle(t("Update email template category"));
    setMasterFormModal(true);
  }

  const handleSubmitEmailCategory = (values: any) => {
    console.log(values);
    if(values.id && values.module_type_id){
      dispatch(EmailCategoryAction.updateEmailCategory(values, props.history));
    }else{
      dispatch(EmailCategoryAction.createEmailCategory(values, props.history));
    }
  };  
  // Master Form --------------------------------------------------------

  // Messages -------------------------------------------------
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorData, setErrorData] = useState({data: {}});

  useEffect(() => {
    if (createEmailCategorySuccessMsg) {
      setSuccessMsg(createEmailCategorySuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(EmailCategoryAction.createEmailCategorySuccess(""));
      setMasterFormModal(false);
    }
  }, [createEmailCategorySuccessMsg]);

  useEffect(() => {
    if (duplicateEmailCategorySuccessMsg) {
      setSuccessMsg(duplicateEmailCategorySuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(EmailCategoryAction.createDuplicateEmailCategorySuccess(""));
    }
  }, [duplicateEmailCategorySuccessMsg]);


  

  useEffect(() => {
    if (createEmailCategoryErrorMsg) {
      setErrorMsg(createEmailCategoryErrorMsg);
      setErrorData({data: createEmailCategoryErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(EmailCategoryAction.createEmailCategoryError(""));
    }
  }, [createEmailCategoryErrorMsg]);

  useEffect(() => {
    if (updateEmailCategorySuccessMsg) {
      setSuccessMsg(updateEmailCategorySuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(EmailCategoryAction.updateEmailCategorySuccess(""));
      setMasterFormModal(false);
    }
  }, [updateEmailCategorySuccessMsg]);

  useEffect(() => {
    if (updateEmailCategoryErrorMsg) {
      setErrorMsg(updateEmailCategoryErrorMsg);
      setErrorData({data: updateEmailCategoryErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(EmailCategoryAction.updateEmailCategoryError(""));
    }
  }, [updateEmailCategoryErrorMsg]);

  useEffect(() => {
    if (deleteEmailCategorySuccessMsg) {
      setSuccessMsg(deleteEmailCategorySuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(EmailCategoryAction.deleteEmailCategorySuccess(""));
      setDeleteModal(false);
    }
  }, [deleteEmailCategorySuccessMsg]);

  useEffect(() => {
    if (deleteEmailCategoryErrorMsg) {
      setErrorMsg(deleteEmailCategoryErrorMsg);
      setErrorData({data: deleteEmailCategoryErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(EmailCategoryAction.deleteEmailCategoryError(""));
      setDeleteModal(false);
    }
  }, [deleteEmailCategoryErrorMsg]);

  useEffect(() => {
    if (getEmailCategoryErrorMsg) {
      setErrorMsg(getEmailCategoryErrorMsg);
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(EmailCategoryAction.getEmailCategoryError(""));
    }
  }, [getEmailCategoryErrorMsg]);
  // Messages -------------------------------------------------


  useEffect(() => {
    setEmailCategoryListData([]);
    setLoadingListData(true);
  }, [localStorage.getItem("I18N_LANGUAGE")]);

  return (
    <React.Fragment>

      {deleteEmailCategory && (
        <DeleteModal
          recordName={recordName}
          modalTitle={t("Email Template Category")}
          show={deleteModal}
          onDeleteClick={handleDeleteEmailCategory}
          onCloseClick={() => setDeleteModal(false)}
          loading={loading}
        />
      )}

      {masterFormModal && (
        <EmailCategoryModal
          modalTitle={masterFormModalTitle}
          show={masterFormModal}
          loading={loading}
          EmailCategoryData={EmailCategoryData}
          onSubmitClick={handleSubmitEmailCategory}
          onCloseClick={() => setMasterFormModal(false)}
          errorMsg={errorMsg}
          errorData={errorData}
        />
      )}

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={t("Email template category")}
            breadcrumbItems={breadcrumbItems}
          />

          <Row>
            <Col xl="12">
              {successMsg ? <Alert color="success">{successMsg}</Alert> : null}
              {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <div className="d-sm-flex flex-wrap">
                    <CardTitle className="card-title text-uppercase">
                      {t("Email template category list")}
                    </CardTitle>
                    <div className="ms-auto d-flex gap-2">
                      <Link
                        to="#"
                        className="btn btn-primary btn-rounded waves-effect waves-light btn-label"
                        onClick={() => onClickModal()}
                      >
                        <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">add</span> {t("Create email template category")}
                      </Link>
                      {/* <Button
                        color="primary"
                        className="btn-rounded waves-effect waves-light"
                      >
                        <i className="fa-solid fa-arrows-rotate"></i>
                      </Button> */}
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <DataTable
                    columns={columns}
                    products={EmailCategoryListData}
                    datatableOptions={datatableOptions}
                    filters={[]}
                    onTableChange={onTableChange}
                    loadingListData={loadingListData}
                    clearFilter={clearFilter}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmailCategory;
